import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {HeaderService} from './header.service';

@Injectable()
export class FirmUsersService extends HeaderService {
  getAllFirmUsers(firmId: String): Observable<any> {
    return this.http.get(environment.apiBaseUrl + 'get-firm-users-for-super-admin/' + firmId,
        this.httpBearerOptions)
        .map((response: Response) => {
          return response;
        })
        .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  createFirmUser(user: any): Observable<any> {
    return this.http.post(environment.apiBaseUrl + 'firm-user/',
        JSON.stringify(user),
        this.httpBearerOptions)
        .map((response: Response) => {
          return response;
        })
        .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }
  updateFirmUser(user: any, id: String): Observable<any> {
    return this.http.put(environment.apiBaseUrl + 'firm-user/' + id,
        JSON.stringify(user),
        this.httpBearerOptions)
        .map((response: Response) => {
          return response;
        })
        .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }
  deleteFirmUser(_id: any): Observable<any> {
    return this.http.delete(environment.apiBaseUrl + 'firm-user/' + _id,
        this.httpBearerOptions)
        .map((response: Response) => {
          return response;
        })
        .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }
  getFirmUser(id: String): Observable<any> {
    return this.http.get(environment.apiBaseUrl + 'get-telemetry-user/' + id,
        this.httpBearerOptions)
        .map((response: Response) => {
          return response;
        })
        .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/firm-users.service.ts